import FeedDetailsLayout from './FeedDetailsLayout';

export default FeedDetailsLayout;
